import { IBarSegmentConfig } from '../../../components/bar-segment-chart/bar-segment-chart';

const WAIST_WIDGET_LABELS: IBarSegmentConfig['labels'] = [
  {
    hidden: true,
    position: 0,
    valueKey: 'weight',
    descriptionKey: 'life_id.bmi_widget_weight',
    unit: 'kg',
    displayedValue: '',
    color: 'rgba(41, 49, 87, 0.6)',
    updateColorFromRange: false,
    addRangeToDisplayedValue: false,
    addUnitToDisplayedValue: false,
    replaceDescriptionWithRange: false,
  },
  {
    hidden: false,
    position: 1,
    valueKey: 'waistCircumference',
    descriptionKey: 'life_id.waist',
    unit: 'cm',
    displayedValue: '',
    customCss: 'highlight bmi-widget-data__fullwidth',
    color: 'rgba(41, 49, 87, 0.6)',
    updateColorFromRange: true,
    addRangeToDisplayedValue: false,
    addUnitToDisplayedValue: true,
    replaceDescriptionWithRange: true,
  },
  {
    hidden: true,
    position: 2,
    valueKey: 'height',
    descriptionKey: 'life_id.bmi_widget_height',
    unit: 'cm',
    displayedValue: '',
    color: 'rgba(41, 49, 87, 0.6)',
    updateColorFromRange: false,
    addRangeToDisplayedValue: false,
    addUnitToDisplayedValue: false,
    replaceDescriptionWithRange: false,
  },
];

const WAIST_RANGES: IBarSegmentConfig['ranges'] = [
  {
    pos: 0,
    name: 'waist_normal',
    from: 0,
    to: 93.9,
    color: '#5FE89C',
  },
  {
    pos: 1,
    name: 'waist_raised',
    from: 94,
    to: 101.9,
    color: '#E5BD6A',
  },
  {
    pos: 2,
    name: 'waist_high',
    from: 102,
    to: 500,
    color: '#FF335C',
  },
];

const WAIST_RANGES_FEMALE: IBarSegmentConfig['ranges'] = [
  {
    pos: 0,
    name: 'waist_normal',
    from: 0,
    to: 79.9,
    color: '#5FE89C',
  },
  {
    pos: 1,
    name: 'waist_raised',
    from: 80,
    to: 87.99,
    color: '#E5BD6A',
  },
  {
    pos: 2,
    name: 'waist_high',
    from: 88,
    to: 300,
    color: '#FF335C',
  },
];

export const WAIST_BAR_CHART_CONFIG: IBarSegmentConfig = {
  labels: WAIST_WIDGET_LABELS,
  ranges: WAIST_RANGES,
  indicatorKey: 'waistCircumference',
};

export const WAIST_BAR_CHART_CONFIG_FEMALE: IBarSegmentConfig = {
  labels: WAIST_WIDGET_LABELS,
  ranges: WAIST_RANGES_FEMALE,
  indicatorKey: 'waistCircumference',
};
